"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TitleEscrowSignable__factory = void 0;

var _ethers = require("ethers");

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const _abi = [{
  inputs: [],
  name: "CallerNotBeneficiary",
  type: "error"
}, {
  inputs: [],
  name: "CallerNotEndorser",
  type: "error"
}, {
  inputs: [],
  name: "CallerNotHolder",
  type: "error"
}, {
  inputs: [],
  name: "EmptyReceivingData",
  type: "error"
}, {
  inputs: [],
  name: "InactiveTitleEscrow",
  type: "error"
}, {
  inputs: [],
  name: "InvalidEndorsement",
  type: "error"
}, {
  inputs: [],
  name: "InvalidNominee",
  type: "error"
}, {
  inputs: [{
    internalType: "address",
    name: "registry",
    type: "address"
  }],
  name: "InvalidRegistry",
  type: "error"
}, {
  inputs: [],
  name: "InvalidSignature",
  type: "error"
}, {
  inputs: [{
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "InvalidTokenId",
  type: "error"
}, {
  inputs: [{
    internalType: "address",
    name: "beneficiary",
    type: "address"
  }, {
    internalType: "address",
    name: "holder",
    type: "address"
  }],
  name: "InvalidTokenTransferToZeroAddressOwners",
  type: "error"
}, {
  inputs: [],
  name: "InvalidTransferToZeroAddress",
  type: "error"
}, {
  inputs: [{
    internalType: "address",
    name: "endorsedBeneficiary",
    type: "address"
  }, {
    internalType: "address",
    name: "currentBeneficiary",
    type: "address"
  }],
  name: "MismatchedEndorsedBeneficiaryAndCurrentBeneficiary",
  type: "error"
}, {
  inputs: [{
    internalType: "address",
    name: "endorsedNominee",
    type: "address"
  }, {
    internalType: "address",
    name: "onChainNominee",
    type: "address"
  }],
  name: "MismatchedEndorsedNomineeAndOnChainNominee",
  type: "error"
}, {
  inputs: [],
  name: "NomineeAlreadyNominated",
  type: "error"
}, {
  inputs: [],
  name: "RecipientAlreadyHolder",
  type: "error"
}, {
  inputs: [],
  name: "RegistryContractPaused",
  type: "error"
}, {
  inputs: [],
  name: "SignatureAlreadyCancelled",
  type: "error"
}, {
  inputs: [{
    internalType: "uint256",
    name: "currentTimestamp",
    type: "uint256"
  }],
  name: "SignatureExpired",
  type: "error"
}, {
  inputs: [],
  name: "TargetNomineeAlreadyBeneficiary",
  type: "error"
}, {
  inputs: [],
  name: "TitleEscrowNotHoldingToken",
  type: "error"
}, {
  inputs: [],
  name: "TokenNotSurrendered",
  type: "error"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "fromBeneficiary",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "toBeneficiary",
    type: "address"
  }, {
    indexed: false,
    internalType: "address",
    name: "registry",
    type: "address"
  }, {
    indexed: false,
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "BeneficiaryTransfer",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "bytes32",
    name: "hash",
    type: "bytes32"
  }, {
    indexed: true,
    internalType: "address",
    name: "endorser",
    type: "address"
  }, {
    indexed: true,
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "CancelBeneficiaryTransferEndorsement",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "fromHolder",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "toHolder",
    type: "address"
  }, {
    indexed: false,
    internalType: "address",
    name: "registry",
    type: "address"
  }, {
    indexed: false,
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "HolderTransfer",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "prevNominee",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "nominee",
    type: "address"
  }, {
    indexed: false,
    internalType: "address",
    name: "registry",
    type: "address"
  }, {
    indexed: false,
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "Nomination",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    internalType: "address",
    name: "registry",
    type: "address"
  }, {
    indexed: false,
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "Shred",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "surrenderer",
    type: "address"
  }, {
    indexed: false,
    internalType: "address",
    name: "registry",
    type: "address"
  }, {
    indexed: false,
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "Surrender",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "beneficiary",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "holder",
    type: "address"
  }, {
    indexed: true,
    internalType: "bool",
    name: "isMinting",
    type: "bool"
  }, {
    indexed: false,
    internalType: "address",
    name: "registry",
    type: "address"
  }, {
    indexed: false,
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "TokenReceived",
  type: "event"
}, {
  inputs: [],
  name: "BENEFICIARY_TRANSFER_TYPEHASH",
  outputs: [{
    internalType: "bytes32",
    name: "",
    type: "bytes32"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "DOMAIN_SEPARATOR",
  outputs: [{
    internalType: "bytes32",
    name: "",
    type: "bytes32"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "active",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "beneficiary",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    components: [{
      internalType: "address",
      name: "beneficiary",
      type: "address"
    }, {
      internalType: "address",
      name: "holder",
      type: "address"
    }, {
      internalType: "address",
      name: "nominee",
      type: "address"
    }, {
      internalType: "address",
      name: "registry",
      type: "address"
    }, {
      internalType: "uint256",
      name: "tokenId",
      type: "uint256"
    }, {
      internalType: "uint256",
      name: "deadline",
      type: "uint256"
    }, {
      internalType: "uint256",
      name: "nonce",
      type: "uint256"
    }],
    internalType: "struct BeneficiaryTransferEndorsement",
    name: "endorsement",
    type: "tuple"
  }],
  name: "cancelBeneficiaryTransfer",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "",
    type: "bytes32"
  }],
  name: "cancelled",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "holder",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "_registry",
    type: "address"
  }, {
    internalType: "uint256",
    name: "_tokenId",
    type: "uint256"
  }],
  name: "initialize",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [],
  name: "isHoldingToken",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "name",
  outputs: [{
    internalType: "string",
    name: "",
    type: "string"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "_nominee",
    type: "address"
  }],
  name: "nominate",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [],
  name: "nominee",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  name: "nonces",
  outputs: [{
    internalType: "uint256",
    name: "",
    type: "uint256"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }, {
    internalType: "address",
    name: "",
    type: "address"
  }, {
    internalType: "uint256",
    name: "_tokenId",
    type: "uint256"
  }, {
    internalType: "bytes",
    name: "data",
    type: "bytes"
  }],
  name: "onERC721Received",
  outputs: [{
    internalType: "bytes4",
    name: "",
    type: "bytes4"
  }],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [],
  name: "registry",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "shred",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes4",
    name: "interfaceId",
    type: "bytes4"
  }],
  name: "supportsInterface",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "surrender",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [],
  name: "tokenId",
  outputs: [{
    internalType: "uint256",
    name: "",
    type: "uint256"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "_nominee",
    type: "address"
  }],
  name: "transferBeneficiary",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    components: [{
      internalType: "address",
      name: "beneficiary",
      type: "address"
    }, {
      internalType: "address",
      name: "holder",
      type: "address"
    }, {
      internalType: "address",
      name: "nominee",
      type: "address"
    }, {
      internalType: "address",
      name: "registry",
      type: "address"
    }, {
      internalType: "uint256",
      name: "tokenId",
      type: "uint256"
    }, {
      internalType: "uint256",
      name: "deadline",
      type: "uint256"
    }, {
      internalType: "uint256",
      name: "nonce",
      type: "uint256"
    }],
    internalType: "struct BeneficiaryTransferEndorsement",
    name: "endorsement",
    type: "tuple"
  }, {
    components: [{
      internalType: "bytes32",
      name: "r",
      type: "bytes32"
    }, {
      internalType: "bytes32",
      name: "s",
      type: "bytes32"
    }, {
      internalType: "uint8",
      name: "v",
      type: "uint8"
    }],
    internalType: "struct SigHelper.Sig",
    name: "sig",
    type: "tuple"
  }],
  name: "transferBeneficiaryWithSig",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "newHolder",
    type: "address"
  }],
  name: "transferHolder",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "_nominee",
    type: "address"
  }, {
    internalType: "address",
    name: "newHolder",
    type: "address"
  }],
  name: "transferOwners",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}];
const _bytecode = "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";

const isSuperArgs = xs => xs.length > 1;

class TitleEscrowSignable__factory extends _ethers.ContractFactory {
  constructor(...args) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  deploy(overrides) {
    return super.deploy(overrides || {});
  }

  getDeployTransaction(overrides) {
    return super.getDeployTransaction(overrides || {});
  }

  attach(address) {
    return super.attach(address);
  }

  connect(signer) {
    return super.connect(signer);
  }

  static createInterface() {
    return new _ethers.utils.Interface(_abi);
  }

  static connect(address, signerOrProvider) {
    return new _ethers.Contract(address, _abi, signerOrProvider);
  }

}

exports.TitleEscrowSignable__factory = TitleEscrowSignable__factory;

_defineProperty(TitleEscrowSignable__factory, "bytecode", _bytecode);

_defineProperty(TitleEscrowSignable__factory, "abi", _abi);